// extracted by mini-css-extract-plugin
module.exports = {"album":"Album_album__lv36S","album__items":"Album_album__items__3q0E1","album__title":"Album_album__title__LWs_x"};